import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export const STATUS_TYPE_BASE = 'base'
export const STATUS_TYPE_IN_PROGRESS = 'in_progress'
export const STATUS_TYPE_COMPLETE = 'complete'

function StatusIcon(props) {
  const { small, type } = props

  return (
    <span
      className={cn('dl-status-icon', {
        'i-small': Boolean(small),
      })}>
      <i
        className={cn('i-base', {
          'i-in-progress': type === STATUS_TYPE_IN_PROGRESS,
          'i-complete': type === STATUS_TYPE_COMPLETE,
        })}
      />
      {/* TODO we'll be use it in the next release */}
      {/* { */}
      {/*    type === STATUS_TYPE_COMPLETE && ( */}
      {/*        <CheckIcon className="icon" /> */}
      {/*    ) */}
      {/* } */}
    </span>
  )
}

StatusIcon.propTypes = {
  small: PropTypes.bool,
  type: PropTypes.oneOf([
    STATUS_TYPE_BASE,
    STATUS_TYPE_IN_PROGRESS,
    STATUS_TYPE_COMPLETE,
  ]),
}

StatusIcon.defaultProps = {
  small: false,
  type: STATUS_TYPE_BASE,
}

export default StatusIcon
